import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

const state = {};

const getters = {};

const mutations = {};

const actions = {
    getKanbansRetorno() {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("kanbans/access/listarKanbansRetorno").then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    getKanbans(context, dados) {
        if((!dados.pagina) || (!dados.quantidadePorPagina)) {
            dados.pagina = 1;
            dados.quantidadePorPagina = 25;
        }
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("kanbans/access/listarComPagina", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getKanbansBox() {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("kanbans/access/listaBox").then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getKanbanBoards(context, dados) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("kanbans/access/listarBoards", { ID_KANBAN: dados.id, componente: dados.componente }).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    getKanban(context, dados) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("kanbans/access/obter", { ID_KANBAN: dados.id, componente: dados.componente }).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    getKanbanBoardTemLeads(context, idKanbanBoard) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("kanbans/access/kanbanBoardTemLeads", { ID_KANBAN_BOARD: idKanbanBoard }).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    deleteKanban(context, dados) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("kanbans/access/excluir", { ID_KANBAN: dados.id, componente: dados.componente }).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    postKanban(context, dados) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("kanbans/access/salvar", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};